import styled from 'styled-components';

import { CalculationNoteOrigin } from 'src/features/incomeVerification/api';

export const NotesLayout = styled.div<{ hasCalculationNotes: boolean }>`
  display: grid;
  grid-template-columns: ${({ hasCalculationNotes }) =>
    hasCalculationNotes ? 'minmax(0, 1fr) minmax(0, 1.15fr)' : 'minmax(0, 1fr)'};
  gap: 1.25rem;
  align-items: start;

  @media ${({ theme }) => theme.device.mobile} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const NotesCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
  padding: 1.375rem 1.5rem;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 1.5rem;
  box-shadow: 0 4px 12px 0 rgba(13, 10, 44, 0.08);
`;

export const NotesCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const NotesCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`;

export const Count = styled.span`
  padding: 0.0625rem 0.5rem;
  border-radius: 999px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  background: ${({ theme }) => theme.color.blue[700]};
  color: ${({ theme }) => theme.color.white};
`;

export const ReadOnlyBadge = styled.span`
  padding: 0.25rem 0.625rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  background: ${({ theme }) => theme.color.gray[100]};
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const Hint = styled.span`
  font-size: 0.8125rem;
  line-height: 1.125rem;
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const Timeline = styled.ol`
  display: flex;
  flex-direction: column;
  max-height: 24rem;
  margin: 0;
  padding: 0 0.5rem 0 0;
  overflow-y: auto;
  list-style: none;
`;

export const TimelineItem = styled.li`
  display: grid;
  grid-template-columns: 0.75rem minmax(0, 1fr);
  column-gap: 0.875rem;
  padding: 0.875rem 0;
  border-top: 1px solid ${({ theme }) => theme.color.gray[200]};

  &:first-child {
    padding-top: 0.25rem;
    border-top: 0;
  }
`;

export const Dot = styled.span<{ origin: CalculationNoteOrigin }>`
  width: 0.625rem;
  height: 0.625rem;
  margin-top: 0.3125rem;
  border-radius: 999px;
  background: ${({ theme, origin }) =>
    origin === 'DISPUTE' ? theme.color.red[700] : theme.color.blue[700]};
`;

export const NoteMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const OriginChip = styled.span<{ origin: CalculationNoteOrigin }>`
  padding: 0.1875rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  background: ${({ theme, origin }) =>
    origin === 'DISPUTE' ? theme.color.red[100] : theme.color.blue[100]};
  color: ${({ theme, origin }) =>
    origin === 'DISPUTE' ? theme.color.red[700] : theme.color.blue[700]};
`;

export const NoteText = styled.p`
  margin: 0.375rem 0 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const ClampedNoteText = styled(NoteText)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
`;

export const NoteField = styled.div`
  && form > div {
    margin-bottom: 0;
  }

  && .input-form {
    padding: 0.875rem 1rem;
    border: 1.5px solid ${({ theme }) => theme.color.blue[200]};
    border-radius: 1rem;
  }

  && .input-form > div:first-of-type {
    display: none;
  }

  && .input-form[data-focused='true'] {
    border-color: ${({ theme }) => theme.color.blue[500]};
  }

  && textarea {
    min-height: 9.375rem;
    font-size: 0.9375rem;
    line-height: 1.5rem;
    resize: vertical;
  }
`;
